/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{53CFD9D0-9CA7-4B28-A6EE-E6EF2FF68761}",
  "sitecoreApiHost": "https://prd-cd.mhealthfairview.org",
  "jssAppName": "MHealthFairviewOrg",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/mhf",
  "graphQLEndpoint": "https://prd-cd.mhealthfairview.org/api/mhf?sc_apikey={53CFD9D0-9CA7-4B28-A6EE-E6EF2FF68761}"
};